import type { FrontendOnlyPieces } from '../../../hooks/useSettings/WebsiteSettings';
import { WalnutPartnersFooter } from '../Footer';

// Walnut Neo — frontend-only pieces; all data fields live on the backend
export const walnutNeoFrontend: FrontendOnlyPieces = {
  slug: 'walnutneo',
  Footer: WalnutPartnersFooter,
};
